import { BaseDataService } from "./base-data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LoadingDataService } from "../repositories/loading-data.service";
import { BusinessDataService } from "./business-data.service";
import { Feature } from "../models/feature";

@Injectable()
export class FeaturesService extends BaseDataService {
  _features: Feature = {} as Feature;

  get newRegulatoryControl(): boolean {
    return this._features && this._features.newRegulatoryControl;
  }

  get canInviteFriend(): boolean {
    return this._features && this._features.canInviteFriend;
  }

  constructor(
    public httpClient: HttpClient,
    public loadingService: LoadingDataService
  ) {
    super(httpClient, loadingService);
  }

  loadFeatures() {
    this.get<Feature>("data/getFeatures", (config) => {
      this._features = config;
    });
  }
}
